var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-preview",class:{ 'steps-preview--half-done': _vm.halfDone }},_vm._l((_vm.steps),function(step,index){return _c('SingleStep',{key:index,attrs:{"is-active":index === _vm.activeStep,"is-done":index < _vm.activeStep,"step-number":index + 1,"title":step}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }